module.exports = __webpack_public_path__ + "static/media/TriAzurIcon.40ace683.png";